// ********** ENUMS AND CONSTS
export var DeliveryQuestionInputType;
(function (DeliveryQuestionInputType) {
    DeliveryQuestionInputType["DROP_DOWN"] = "Dropdown";
    DeliveryQuestionInputType["TEXT_BOX"] = "Textbox";
})(DeliveryQuestionInputType || (DeliveryQuestionInputType = {}));
export var AddressesText;
(function (AddressesText) {
    AddressesText["ADD_ADDRESS"] = "Add Address";
    AddressesText["ADD_NEW_ADDRESS"] = "Add New Address";
    AddressesText["ADDRESS"] = "Address";
    AddressesText["ADDRESS_ADDED"] = "Address successfully added!";
    AddressesText["ADDRESS_UPDATED"] = "Address successfully updated!";
    AddressesText["APT_SUITE_ETC"] = "Apt, suite, etc.";
    AddressesText["BAD_ZIP_FIELD_MSG"] = "Please provide a valid postal code.";
    AddressesText["BAD_ZIP_TOAST"] = "Sorry, we do not provide service to this postal code.";
    AddressesText["CITY"] = "City";
    AddressesText["DELIVERY_ADDRESSES"] = "Delivery Addresses";
    AddressesText["FIRST_NAME"] = "First name";
    AddressesText["LAST_NAME"] = "Last name";
    AddressesText["MAKE_PRIMARY"] = "Make Primary";
    AddressesText["NO_ADDRESSES_FOUND"] = "No addresses found! Please add one.";
    AddressesText["NONE"] = "None";
    AddressesText["PLEASE_ENTER_ZIP"] = "Please enter a zip code before making this your primary address.";
    AddressesText["POSTAL_CODE"] = "Postal code";
    AddressesText["PRIMARY"] = "Primary";
    AddressesText["PRIMARY_INFO_NOT_FOUND"] = "Primary address information not found!";
    AddressesText["REQUIRED_QUESTION"] = "This is a required question.";
    AddressesText["SORRY_NO_CHANGE_ZIP"] = "Sorry, you cannot change the postal code on an existing address. Please add a new address instead.";
    AddressesText["STATE_PROVINCE"] = "State/Province";
    AddressesText["SUBMIT"] = "Submit";
    AddressesText["THIS_IS_PRIMARY"] = "This is your primary address.";
    AddressesText["UPDATE"] = "Update";
    AddressesText["UPDATE_ADDRESS"] = "Update Address";
})(AddressesText || (AddressesText = {}));
export const deliveryQuestionsFieldNamePrefix = `delivery-questions`;
